





















import {Component, Prop, Vue} from 'vue-property-decorator'
import ModalPopup from '@/components/dialogs/ModalPopup.vue'
import Button from '@/components/buttons/Button.vue'

@Component({
  components: {
    ModalPopup,
    Button,
  },
})

export default class DuplicatePanelPopup extends Vue {
  @Prop(String) public panelName?: string
  private name?: string = ''

  public close() {
    this.$emit('close')
  }

  public duplicate() {
    this.$emit('update:panelName', this.name)
    this.$emit('save', this.name)
  }

  public created() {
    this.name = this.panelName
  }

  public mounted() {
    this.$nextTick(() => {
      (this.$refs.panelNameInput as HTMLElement).focus()
    })
  }
}
